import React, { useEffect, useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import toast from "react-hot-toast";
import SecondaryButton from "../../components/SecondaryButton";
import { signInWithEmailAndPassword } from "firebase/auth";
import PageHeader from "../../components/PageHeader";
import InputField from "../../components/InputField";
import { auth } from "../../config/firebaseConfig";
import { BsEye } from "react-icons/bs";
import PasswordInputField from "../../components/PasswordField";
import axiosInstance from "../../utils/axiosInstance";
import { fetchDoctorCategories, imageBaseUrl, registerUser, updateDoctorDetails, updateUserDetais } from "../../constants/ApiConstants";
import { Link, redirect, useNavigate } from "react-router-dom";
import SelectField from "../../components/SelectField";
import SelectField2 from "../../components/SelectField2";
import { countries } from "../../utils/countries";
import MobileNumberWithCountryCode from "../../components/MobileNumberWithCountryCode";
import DatePicker from "react-datepicker";
import { getYYYYmmddFromDate } from "../../utils/utils";
import { updateDoctorData, updateUserData } from "../../store/appSlice";
import { FaX } from "react-icons/fa6";
import FullPageLoader from "../../components/FullPageLoader";
import ListEmptyText from "../../components/ListEmptyText";
import { primaryColor, surfaceColor1, surfaceColor2, surfaceColor3 } from "../../constants/colors";
import CommonMobileHeader from "../../components/Header/CommonMobileHeader";

export default function SelectCategory() {
  pageTitle("Select a category");

  const [loading, setLoading] = useState(false);
  const doctorData = useSelector((state) => state.appSlice.doctorData);
  const [categories, setCategories] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [categoryId, setCategoryId] = useState("");
  const [searchTerm, setSearchText] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    navigatePage(doctorData);
  }, [doctorData, navigate]);

  function fetchCategories() {
    setLoading(true);
    axiosInstance
      .post(fetchDoctorCategories)
      .then((res) => setCategories(res.data.data))
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const handleSubmitClick = async () => {
    if (!categoryId) {
      toast.error("Please choose a category");
      return;
    }
    const payload = {
      doctor_id: doctorData?.id,
      category_id: categoryId,
    };
    try {
      setSubmitting(true);
      const response = await axiosInstance.post(updateDoctorDetails, {
        ...payload,
      });
      if (response.data?.status) {
        toast.success("Doctor details has been updated.");
        dispatch(updateDoctorData(response?.data?.data));
        navigatePage(response?.data?.data);
      } else {
        toast.error(response.data?.message);
      }
      setSubmitting(false);
    } catch (err) {
      console.log(err);
      // toast.error(err.response.data?.message);
      setSubmitting(false);
    }
  };

  function navigatePage(doctorData) {
    if (doctorData.category_id) {
      navigate("/doctor-profile");
    }
  }

  const onCategorySelect = (cat) => {
    setCategoryId(cat.id);
  };
  const onSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const getFilteredCats = () => (searchTerm === "" ? [...categories] : categories?.filter((it) => it.title.includes(searchTerm)));

  return (
    <Wrapper>
      <Section topMd={60} topLg={20} topXl={20} bottomMd={200} bottomLg={150} bottomXl={110}>
        {loading && !categories ? (
          <FullPageLoader />
        ) : (
          <div className="content-wrapper d-flex flex-column p-3 gap-1 justify-content-center">
            <div className="col-sm-6 col-md-6 g-2 mx-auto">
              <CommonMobileHeader title={"Choose category"} />
              <p className="m-2">Select Your category</p>
              <div className="d-flex bg-grey2 w-100 rounded-pill position-relative">
                <input type="text" placeholder="Search" className="fs-normal bg-transparent border-0 px-3 py-2 text-black w-75" value={searchTerm} onChange={onSearchChange} />
                {searchTerm !== "" && (
                  <button onClick={() => setSearchText("")} type="button" className="d-flex justify-content-center align-items-center position-absolute bg-grey1" style={{ right: 8, height: 28, width: 28, borderRadius: 100, top: "15%" }}>
                    <FaX color="#000" size={13} />
                  </button>
                )}
              </div>
              <p className="fs-md text-grey2 p-2"></p>
              {!loading && categories?.length === 0 && <ListEmptyText text="Categories Not Available." />}
              {!loading && categories?.length > 0 && (
                <div className="row mb-2">
                  {getFilteredCats()?.map((cat) => (
                    <div key={cat.id} className="col-6 col-md-6 col-sm-6 col-lg-4 py-1 px-2" onClick={() => onCategorySelect(cat)} style={{ cursor: "pointer" }}>
                      <div className="d-flex flex-column gap-1 py-3 px-3 rounded justify-content-around" style={{ background: categoryId === cat.id ? primaryColor : `${surfaceColor3}`, height: "100px" }}>
                        <img className="img-fluid" src={`${imageBaseUrl}${cat.image}`} alt="" style={{ height: 28, width: 28, borderRadius: 100 }} />
                        <strong className={`${categoryId === cat.id ? "text-white" : "text-sprimary"} fs-sm`} style={{ lineHeight: "1.2" }}>
                          {cat.title}
                        </strong>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <SecondaryButton title={"Submit"} className={"mt-3"} onClick={handleSubmitClick} loading={submitting} />
            </div>
          </div>
        )}
      </Section>
    </Wrapper>
  );
}
const Wrapper = styled.div``;
